// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.tabs-container .tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid var(--accent-color, #f1662a);
}
.tabs-container .tabs-header .tabs-left {
  display: flex;
  gap: 8px;
}
.tabs-container .tabs-header .tabs-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.tabs-container .tabs-header .tab-item {
  padding: 0.8rem 1.6rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  border-bottom: 2px solid transparent;
  background-color: #dedede;
  border-radius: 4px 4px 0 0;
}
.tabs-container .tabs-header .tab-item:hover {
  background-color: rgb(209.25, 209.25, 209.25);
}
.tabs-container .tabs-header .tab-item.active {
  border-bottom: none;
  color: white;
  background-color: var(--accent-color, #f1662a);
}
.tabs-container .tabs-header .tab-item:focus {
  outline: none;
}
.tabs-container .tabs-content {
  flex: 1 1;
  padding: 1rem 0;
}
.tabs-container .tabs-content .tab-panel {
  display: none;
}
.tabs-container .tabs-content .tab-panel.active {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/TabsContainer/TabsContainer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qDAAA;AACJ;AACI;EACE,aAAA;EACA,QAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAAN;AAGI;EACE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,0BAAA;AADN;AAGM;EACE,6CAAA;AADR;AAIM;EACE,mBAAA;EACA,YAAA;EACA,8CAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAQE;EACE,SAAA;EACA,eAAA;AANJ;AAQI;EACE,aAAA;AANN;AAQM;EACE,cAAA;AANR","sourcesContent":[".tabs-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  .tabs-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 2px solid var(--accent-color, #f1662a);\n\n    .tabs-left {\n      display: flex;\n      gap: 8px;\n    }\n\n    .tabs-right {\n      display: flex;\n      align-items: center;\n      margin-left: auto;\n    }\n\n    .tab-item {\n      padding: 0.8rem 1.6rem;\n      cursor: pointer;\n      transition: all 0.2s ease-in-out;\n      font-weight: 500;\n      border-bottom: 2px solid transparent;\n      background-color: #dedede;\n      border-radius: 4px 4px 0 0;\n\n      &:hover {\n        background-color: darken(#dedede, 5%);\n      }\n\n      &.active {\n        border-bottom: none;\n        color: white;\n        background-color: var(--accent-color, #f1662a);\n      }\n\n      &:focus {\n        outline: none;\n      }\n    }\n  }\n\n  .tabs-content {\n    flex: 1;\n    padding: 1rem 0;\n\n    .tab-panel {\n      display: none;\n\n      &.active {\n        display: block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
